// @flow

import React from "react";
import { localize } from "redux-i18n";
import actionCreators from "@modules/service/actionCreator";
import { Button, SchemaForm, Modal, ModalBody, ModalFooter, ModalHeader, Col } from "@components";
import type { ExclusionReasonDetails } from "@modules/employee/reducer/personal-details/types";
import { split } from "@transformers/schema";
import { uiSchema } from "./uiSchema";

type OwnProps = $Exact<{
  onDismissHandler: () => void,
  onSubmit: (form: Object) => void,
  formData: ExclusionReasonDetails,
  schema: Object,
  alertExclusionAlertsOptions: Array<Object>,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class ExcludeEmployeeFromAlertsEditModal extends React.Component<Props> {
  exclusionReasonSchema = split(this.props.schema, [
    "exclusionReason",
    "activeFrom",
    "activeTo",
    "alertConfiguration",
  ]);

  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }

  submitForm = () => {
    if (this.formRef) {
      this.formRef.current.submit();
    }
  };

  handleSubmit = (formData: Object) => {
    this.props.onSubmit(formData);
  };

  getSchema = (options: Array<Object>) => {
    this.exclusionReasonSchema.properties.exclusionReason.properties.id.oneOf = options;
    return this.exclusionReasonSchema;
  };

  render() {
    return (
      <Modal className="modal-small">
        <ModalHeader
          toggle={this.props.onDismissHandler}
          className="d-flex justify-content-between"
        >
          {this.props.t("EDIT_ALERT_EXLUSION")}
        </ModalHeader>
        <ModalBody>
          <Col sm={{ size: 10, offset: 1 }}>
            <SchemaForm
              ref={this.formRef}
              formData={this.props.formData}
              schema={this.getSchema(this.props.alertExclusionAlertsOptions)}
              onSubmit={this.handleSubmit}
              uiSchema={uiSchema(this.props.t)}
              externalSubmit
            />
          </Col>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onDismissHandler}>
            {this.props.t("CANCEL")}
          </Button>
          <Button materialIcon="save" onClick={this.submitForm}>
            {this.props.t("SAVE")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(ExcludeEmployeeFromAlertsEditModal);
